{
  "breadcrumbAriaLabel": "เส้นทางนำทาง",
  "homeAriaLabel": "หน้าแรก",
  "mainNavAriaLabel": "การนำทางหลัก",
  "closeSidebarAriaLabel": "ปิดแถบด้านข้าง",
  "collapse": "ย่อ",
  "help": "ช่วยเหลือ",
  "settings": "ตั้งค่า",
  "myProfile": "โปรไฟล์ของฉัน",
  "groups": {
    "clinical": "งานคลินิก",
    "worklists": "รายการงาน",
    "documentation": "บันทึกทางคลินิก",
    "orders": "คำสั่งการรักษา",
    "medications": "ยา",
    "scheduling": "การนัดหมาย",
    "billing": "การเรียกเก็บเงิน",
    "analytics": "การวิเคราะห์",
    "organization": "องค์กร",
    "security": "ความปลอดภัย",
    "accessReviews": "Access Reviews",
    "integrations": "การเชื่อมต่อ",
    "system": "ระบบ",
    "licensing": "ใบอนุญาต"
  },
  "dashboard": "แดชบอร์ด",
  "patients": "ผู้ป่วย",
  "patientSearch": "ค้นหาผู้ป่วย",
  "myPatients": "ผู้ป่วยของฉัน",
  "censusBedBoard": "ผู้ป่วยใน / ผังเตียง",
  "providerDirectory": "ทำเนียบแพทย์",
  "providerCoverage": "ตารางเวรแพทย์",
  "patientMerge": "รวมข้อมูลผู้ป่วย",
  "inbox": "กล่องข้อความ",
  "pendingResults": "ผลตรวจรอตรวจสอบ",
  "criticalResults": "ผลตรวจวิกฤต",
  "unsignedNotes": "บันทึกที่ยังไม่ลงนาม",
  "cosignQueue": "คิวลงนามร่วม",
  "noteTemplates": "เทมเพลตบันทึก",
  "smartPhrases": "วลีอัจฉริยะ",
  "orderCatalog": "แคตตาล็อกคำสั่ง",
  "orderSets": "ชุดคำสั่ง",
  "encounters": "การเข้ารับบริการ",
  "orders": "คำสั่งการรักษา",
  "results": "ผลตรวจ",
  "medications": "ยา",
  "notes": "บันทึกทางคลินิก",
  "medicationWorklist": "Medication Worklist",
  "formulary": "บัญชียา",
  "pharmacistQueue": "คิวเภสัชกร",
  "appointments": "นัดหมาย",
  "scheduleManagement": "จัดการตารางนัด",
  "waitlist": "รายการรอ",
  "charges": "รายการเรียกเก็บ",
  "claims": "เคลม",
  "payments": "การชำระเงิน",
  "accounts": "บัญชี",
  "statements": "ใบแจ้งหนี้",
  "denials": "การปฏิเสธจ่าย",
  "analyticsDashboard": "แดชบอร์ด",
  "reports": "รายงาน",
  "qualityMeasures": "ตัวชี้วัดคุณภาพ",
  "healthSystems": "เครือโรงพยาบาล",
  "facilities": "สถานพยาบาล",
  "locations": "สถานที่",
  "clinicalTaxonomy": "การจำแนกทางคลินิก",
  "serviceLocation": "บริการ ↔ สถานที่",
  "providers": "บุคลากรทางการแพทย์",
  "users": "ผู้ใช้",
  "roles": "บทบาท",
  "accessMatrix": "ตารางสิทธิ์",
  "integrations": "การเชื่อมต่อ",
  "thirdPartyApps": "แอปบุคคลที่สาม",
  "audit": "การตรวจสอบ",
  "system": "ระบบ",
  "cdsRules": "กฎ CDS",
  "escalationRules": "Escalation Rules",
  "segments": {
    "search": "ค้นหา",
    "register": "ลงทะเบียน",
    "demographics": "ข้อมูลพื้นฐาน",
    "census": "ผู้ป่วยใน",
    "discharge": "จำหน่าย",
    "catalog": "แคตตาล็อก",
    "sets": "ชุดคำสั่ง",
    "pending": "รอดำเนินการ",
    "critical": "วิกฤต",
    "reconciliation": "การกระทบยอดยา",
    "worklist": "รายการงาน",
    "templates": "เทมเพลต",
    "smartPhrases": "วลีอัจฉริยะ",
    "schedule": "จัดการตารางนัด",
    "quality": "ตัวชี้วัดคุณภาพ",
    "administration": "การจัดการ",
    "auditLog": "บันทึกการตรวจสอบ",
    "allergies": "ภูมิแพ้",
    "problems": "รายการปัญหา",
    "immunizations": "การฉีดวัคซีน",
    "insurance": "ประกัน"
  },
  "handoffs": "การส่งเวร",
  "duplicateReview": "การตรวจสอบข้อมูลซ้ำ",
  "sso": "SSO & Directories",
  "userGroups": "User Groups",
  "fileKey": "File key",
  "ordersWorklist": "รายการงานคำสั่ง"
}
